import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_CAMPAIGN_FACETS_QUERY_KEY,
  BRIEF_CAMPAIGNS_LIST_QUERY_KEY,
} from "../contsants";
import { useEffect } from "react";
import { CampaignService } from "../services/Campaign.service";
import { IBriefCampaignInfluencerSearchRequestV2 } from "@shared/lib/types/briefCampains";

export function useGetCampaignFacets(briefId: string) {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [...BRIEF_CAMPAIGN_FACETS_QUERY_KEY(briefId)],
    queryFn: () => CampaignService.getBriefCampaignFacets(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    briefCampaignsFacets: data?.data,
    isLoading,
    isError,
    refetch,
  };
}
